import {
  Icon,
  IconButton,
  useDisclosure,
  Text,
  VStack,
  Box,
  Divider,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
  PopoverHeader,
  Portal,
} from '@chakra-ui/react';
import { FiInfo } from 'react-icons/fi';

export default function InformationSourcePopup({ title, content }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Popover
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      placement="auto"
      isLazy
    >
      <PopoverTrigger>
        <IconButton
          variant="ghost"
          colorScheme="blue"
          icon={<Icon as={FiInfo} boxSize="16px" />}
          aria-label="info"
          size="xs"
          zIndex="10!important"
          _focus={{ boxShadow: 'none' }}
          className="hidden-print"
          onClick={onOpen}
        />
      </PopoverTrigger>
      <Portal>
        <Box position="relative" zIndex={9999}>
          <PopoverContent
            _focus={{ boxShadow: 'lg' }}
            width="fit-content"
            maxWidth="800px"
            minWidth="200px"
            zIndex="9999"
          >
            <PopoverArrow />
            <PopoverCloseButton />
            {title && (
            <PopoverHeader fontWeight="bold" fontSize="md">
              {title}
            </PopoverHeader>
            )}
            <PopoverBody>
              {content
              && (
              <VStack
                spacing={4}
                justify="flex-start"
                align="flex-start"
              >
                {content.map((item, index) => (
                  <Box key={index} fontSize="sm" width="100%">
                    <Text fontWeight="bold" fontSize="inherit" mb={2}>{item.title}</Text>
                    {item.description}
                    {item.source && (
                    <Text fontSize="xs" mt={2}>
                      <Text
                        as="span"
                        mr={1}
                        fontSize="inherit"
                        fontWeight="bold"
                      >
                        Source:
                      </Text>
                      {item.source}
                    </Text>
                    )}
                    {index !== content.length - 1 && <Divider mt={4} />}
                  </Box>
                ))}
              </VStack>
              )}
            </PopoverBody>
          </PopoverContent>
        </Box>
      </Portal>
    </Popover>
  );
}
